module.exports = __webpack_public_path__ + "static/img/user_card.216053d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my/user_card.png
// module id = Etxp
// module chunks = 1